/**
 * @author        nico@zumper.com (Nico Rattazzi)
 * @copyright     Copyright (c) 2017, Zumper
 * @description   API for local storage
 */

import { LocalStorage, addTrackingToUrl as _addTrackingToUrl } from '@zcode/legacy-local-storage'
import type { LinkProps } from 'react-router-dom'
import { STORAGE_PREFIX } from '../../settings'
import { ON_SERVER } from '../env'

export const localStorageSingleton = new LocalStorage({ prefix: STORAGE_PREFIX, server: ON_SERVER })

export function addTrackingToUrl<T extends LinkProps['to'] | undefined>(to: T) {
  return _addTrackingToUrl<T>(localStorageSingleton, to)
}
